import { COLOR } from 'src/constants/colors'
import { RootState } from 'src/store/store'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import { commonUtils } from 'src/utils/common.utils'
import { ColorHandler } from 'src/utils/style.utils'
import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import Svg from 'src/components/atomic/atom/Svg'
import { HomeDataPropsType } from 'src/views/Service/Home'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import Spinner from 'src/components/atomic/atom/Spinner'

const HomeDeviceInfoCard = (props: { data: HomeDataPropsType }) => {
  const { onDeviceRefreshBtnHandler, refreshStatus } = props.data
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()
  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const { LastUpdateDT, Model } = useAppSelector((state: RootState) => state.HomePage)
  const { setDateFormat } = commonUtils
  return (
    <Div
      display={'block'}
      $border_radius={'12px'}
      $border={`1px solid ${COLOR.black20}`}
      $margin={setMediaStyle('33px auto', '16px auto 19.5px auto', '16px auto 24px auto')}
      $padding={setMediaStyle('24px', '16px', '16px')}
      height={setMediaStyle('128px', '91px', '101px')}
    >
      {Model?.length === 0 || LastUpdateDT === 0 ? (
        <Spinner />
      ) : (
        <>
          <Span
            display={'flex'}
            $text_align={'left'}
            option={setMediaStyle('Large_bold', 'small_bold', 'small_bold')}
          >
            {Model}
            <Svg
              name={`home_DeviceInfo_Reload_${refreshStatus ? 'active' : 'disabled'}`}
              color={ColorHandler(refreshStatus, 'brand_black30')}
              width={setMediaStyle('21px', '16px', '16px')}
              height={setMediaStyle('21px', '16px', '16px')}
              $margin={setMediaStyle('4.5px 0 0 8px', '2px 0 0 5px', '2px 0 0 5px')}
              onClick={onDeviceRefreshBtnHandler}
              style={{
                pointerEvents: refreshStatus ? 'unset' : 'none',
              }}
            />
          </Span>
          <Div
            display={'flex'}
            $align_item={'center'}
            height={setMediaStyle('32px', '24px', '34px')}
            $margin={setMediaStyle('16px 0 0 0', '12px 0 0 0', '12px 0 0 0')}
          >
            <Span
              option={'mini_bold'}
              width={'auto'}
              color={ColorHandler(Connection, 'brand_black30')}
              $whitespace={'nowrap'}
            >
              {Connection
                ? t('HOME.STATUS_ON', { defaultValue: 'On-line' })
                : t('HOME.STATUS_OFF', { defaultValue: 'Off-line' })}
            </Span>
            {/*line*/}
            <Div
              style={{ borderRight: `1px solid ${COLOR.black8}` }}
              height={setMediaStyle('32px', '24px', '24px')}
              $margin={setMediaStyle('0 20px', '0 14px', '0 14px')}
            />
            <Div width={'100%'} $align_item={'center'} display={'flex'}>
              <Span
                option={'mini_bold'}
                width={'auto'}
                $margin={setMediaStyle('0 12px 0 0', '0 8.5px 0 0', '0 8.5px 0 0')}
                $whitespace={'nowrap'}
              >
                {t('HOME.DATE_DESC', { defaultValue: 'Last updated' })}
              </Span>
              <Span
                width={'auto'}
                option={'mini_bold'}
                $whitespace={'normal'}
                style={{
                  maxWidth: setMediaStyle('167px', '300px', '130px'),
                }}
                $text_align={'left'}
                color={COLOR.bluegray30}
              >
                {LastUpdateDT && setDateFormat('HOME', LastUpdateDT)}
              </Span>
            </Div>
          </Div>
        </>
      )}
    </Div>
  )
}
export default HomeDeviceInfoCard
